module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "count-down"
  }, [_c('div', {
    staticClass: "fz-32",
    staticStyle: {
      "color": "#FF8C00"
    }
  }, [_vm._v(_vm._s(_vm.countDownLatch) + "s")])]), _vm._v(" "), _c('div', {
    staticClass: "selfInfo1",
    staticStyle: {
      "width": "100%",
      "padding": "0"
    }
  }, [_c('img', {
    staticClass: "guizi",
    staticStyle: {
      "width": "1.56rem"
    },
    attrs: {
      "src": require("../assets/images/img-guizi@2x.png")
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "fz-32",
    staticStyle: {
      "margin": ".55rem 0 .2rem 0",
      "padding": "0 .5rem"
    }
  }, [_c('img', {
    staticClass: "dingwei",
    attrs: {
      "src": require("../assets/images/icon-dingwei@2x.png")
    }
  }), _vm._v("\n      " + _vm._s(_vm.orderInfo.orderPickUpInfoBean.deviceName) + "\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "cell-no"
  }, [_c('div', {
    staticClass: "no",
    staticStyle: {
      "font-size": "1.2rem"
    }
  }, [_vm._v("\n        " + _vm._s(_vm.orderInfo.orderPickUpInfoBean.cellNo) + "\n      ")])]), _vm._v(" "), _c('div', {
    staticClass: "fz-32",
    staticStyle: {
      "margin-top": ".4rem"
    }
  }, [_vm._v("箱门已打开")]), _vm._v(" "), _c('div', {
    staticClass: "fz-32",
    staticStyle: {
      "margin-bottom": ".4rem"
    }
  }, [_vm._v("请取走您的餐盒并关好箱门")]), _vm._v(" "), _c('div', {
    staticClass: "btn-open fz-32",
    staticStyle: {
      "height": "1rem",
      "line-height": "1rem"
    },
    on: {
      "click": _vm.closePage
    }
  }, [_vm._v("确认已取，并关好箱门")]), _vm._v(" "), _c('div', {
    staticClass: "fz-30",
    staticStyle: {
      "color": "#4A90E2",
      "margin-top": ".4rem"
    },
    on: {
      "click": _vm.sureCabinet
    }
  }, [_vm._v("箱门未开，重试箱门")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-148d4f25","hasScoped":true}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/pages/DeviceDetail.vue
// module id = 414
// module chunks = 7